module.exports = __webpack_public_path__ + "static/media/intro-photowall-11.434627e4.jpg";